import { useSelector } from 'react-redux'

import { useFlags } from '@lyrahealth-inc/shared-app-logic/src/features/flags/useFlags'

import { getAuthConfig } from '../../data/auth/authSelectors'

export const useNewDashboard = () => {
  const { isDADashboardEnabled } = useFlags()
  const config = useSelector(getAuthConfig)
  return isDADashboardEnabled && config?.useNewDashboard
}
